'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {};
    },
    computed: {
        showBadge: function showBadge() {
            return this.openAssessments > 0 ? true : false;
        }
    },
    methods: {},
    props: ['verified', 'loginUrl', 'logoutUrl', 'assessmentsUrl', 'fullname', 'openAssessments']
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/my-account.vue
// module id = ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/my-account.vue
// module chunks = 0